module.exports = __webpack_public_path__ + "img/p3.3a55ca9f.png";